let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1y4lD")).then(() => parcelRequire('d0Htp'));